import React, { useState } from 'react';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { loginAdmin, isLoading } = useAdminAuth();
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');

        const result = await loginAdmin(username, password);
        if (result.success) {
            navigate('/admin/dashboard');
        } else {
            setError(result.error);
        }
    };

    const handleBackToCatalog = () => {
        navigate('/');
    };

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '20px',
            position: 'relative'
        }}>
            {/* Bouton retour */}
            <div style={{ 
                position: 'absolute', 
                top: '20px', 
                left: '20px' 
            }}>
                <button
                    onClick={handleBackToCatalog}
                    style={{
                        background: '#6c757d',
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '14px'
                    }}
                >
                    ← Back to Catalog
                </button>
            </div>
            
            <div style={{
                background: 'white',
                padding: '40px',
                borderRadius: '12px',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                maxWidth: '400px',
                width: '100%'
            }}>
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <h2 style={{ margin: '0 0 10px 0', color: '#333' }}>
                        🔐 Admin Portal
                    </h2>
                    <p style={{ color: '#666', margin: 0 }}>
                        Sign in to manage customer access
                    </p>
                </div>

            <form onSubmit={handleLogin}>
                <div style={{ marginBottom: '20px' }}>
                    <label style={{ 
                        display: 'block', 
                        marginBottom: '8px', 
                        fontWeight: '600',
                        color: '#333'
                    }}>
                        Username:
                    </label>
                    <input
                        type="text"
                        required
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        style={{
                            width: '100%',
                            padding: '12px',
                            border: '2px solid #e0e0e0',
                            borderRadius: '8px',
                            fontSize: '16px',
                            boxSizing: 'border-box'
                        }}
                        placeholder="Enter your username"
                    />
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <label style={{ 
                        display: 'block', 
                        marginBottom: '8px', 
                        fontWeight: '600',
                        color: '#333'
                    }}>
                        Password:
                    </label>
                    <input
                        type="password"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{
                            width: '100%',
                            padding: '12px',
                            border: '2px solid #e0e0e0',
                            borderRadius: '8px',
                            fontSize: '16px',
                            boxSizing: 'border-box'
                        }}
                        placeholder="Enter your password"
                    />
                </div>

                {error && (
                    <div style={{
                        background: '#ffebee',
                        color: '#c62828',
                        padding: '12px',
                        borderRadius: '6px',
                        marginBottom: '20px',
                        fontSize: '14px',
                        border: '1px solid #ffcdd2'
                    }}>
                        ❌ {error}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={isLoading}
                    style={{
                        width: '100%',
                        background: isLoading ? '#ccc' : 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
                        color: 'white',
                        border: 'none',
                        padding: '14px',
                        borderRadius: '8px',
                        fontSize: '16px',
                        fontWeight: '600',
                        cursor: isLoading ? 'not-allowed' : 'pointer',
                        transition: 'all 0.3s ease'
                    }}
                >
                    {isLoading ? '⏳ Signing in...' : '🔓 Sign In as Admin'}
                </button>
            </form>

            <div style={{ 
                marginTop: '20px', 
                padding: '15px',
                background: '#f8f9fa',
                borderRadius: '8px',
                fontSize: '14px',
                color: '#666',
                textAlign: 'center'
            }}>
                💡 <strong>Admin Access Only</strong><br/>
                This interface is for administrators to manage customer portal access.
            </div>
        </div>
        </div>
    );
};

export default AdminLogin;
